var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "发货",
        width: "696px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.config.visible,
        callback: function ($$v) {
          _vm.$set(_vm.config, "visible", $$v)
        },
        expression: "config.visible",
      },
    },
    [
      _c("div", { staticClass: "sendGoods overflowOuto" }, [
        _c("div", { staticClass: "m-b-20 form_row" }, [
          _c(
            "div",
            { staticClass: "form_view", staticStyle: { width: "377px" } },
            [
              _c("div", { staticClass: "form_label m-l-16" }, [
                _vm._v("用户昵称："),
              ]),
              _c("div", { staticClass: "form_value" }, [
                _vm._v(_vm._s(_vm.filtersTextPhone(_vm.detail.winnerUserName))),
              ]),
            ]
          ),
          _c("div", { staticClass: "form_view" }, [
            _c("div", { staticClass: "form_label" }, [_vm._v("手机号码：")]),
            _c(
              "div",
              { staticClass: "form_value" },
              [
                _c("watchPhoneNumber", {
                  attrs: {
                    "default-value": _vm.detail.winnerUserPhone,
                    params: _vm.detail,
                    "user-id": _vm.detail.winnerUserId,
                    "get-api": _vm.operationLogsWrite,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
        _c("div", { staticClass: "recipient" }, [
          _c("div", { staticClass: "form_row" }, [
            _c(
              "div",
              {
                staticClass: "form_view m-b-10",
                staticStyle: { width: "357px" },
              },
              [
                _c("div", { staticClass: "form_label" }, [_vm._v("收件人：")]),
                _c("div", { staticClass: "form_value" }, [
                  _vm._v(_vm._s(_vm.detail.addressee)),
                ]),
              ]
            ),
            _c("div", { staticClass: "form_view" }, [
              _c("div", { staticClass: "form_label" }, [
                _vm._v("收件人电话："),
              ]),
              _c("div", { staticClass: "form_value" }, [
                _vm._v(
                  " " + _vm._s(_vm.Decrypt(_vm.detail.addresseePhone)) + " "
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "form_row" }, [
            _c("div", { staticClass: "form_view" }, [
              _c("div", { staticClass: "form_label" }, [_vm._v("收件地址：")]),
              _c("div", { staticClass: "form_value" }, [
                _vm._v(_vm._s(_vm.detail.recipientAddress)),
              ]),
            ]),
          ]),
        ]),
        _vm.config.type === 1
          ? _c(
              "div",
              { staticStyle: { "margin-top": "15px" } },
              [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      "label-width": "auto",
                      size: "small",
                      rules: _vm.rules,
                    },
                    nativeOn: {
                      submit: function ($event) {
                        $event.preventDefault()
                      },
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "快递公司", prop: "expressCompany" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "245px" },
                            attrs: { clearable: "", placeholder: "请选择" },
                            model: {
                              value: _vm.form.expressCompany,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "expressCompany", $$v)
                              },
                              expression: "form.expressCompany",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "顺丰快递", value: 1 },
                            }),
                            _c("el-option", {
                              attrs: { label: "圆通快递", value: 2 },
                            }),
                            _c("el-option", {
                              attrs: { label: "中通快递", value: 3 },
                            }),
                            _c("el-option", {
                              attrs: { label: "韵达快递", value: 4 },
                            }),
                            _c("el-option", {
                              attrs: { label: "申通快递", value: 5 },
                            }),
                            _c("el-option", {
                              attrs: { label: "百世汇通", value: 6 },
                            }),
                            _c("el-option", {
                              attrs: { label: "中国邮政", value: 7 },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "快递单号", prop: "trackingNumber" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "245px" },
                          attrs: { clearable: "", maxlength: "50" },
                          model: {
                            value: _vm.form.trackingNumber,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "trackingNumber",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.trackingNumber",
                          },
                        }),
                        _c("div", { staticClass: "errorTips" }, [
                          _vm._v("仔细核对快递单号，请勿出错！"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.config.type === 2
          ? _c("div", { staticStyle: { "margin-top": "16px" } }, [
              _c("div", { staticClass: "form_row" }, [
                _c(
                  "div",
                  {
                    staticClass: "form_view m-b-10",
                    staticStyle: { width: "377px" },
                  },
                  [
                    _c("div", { staticClass: "form_label m-l-16 f-s-14" }, [
                      _vm._v("快递公司："),
                    ]),
                    _c("div", { staticClass: "form_value f-s-14" }, [
                      _vm._v(
                        _vm._s(
                          {
                            1: "顺丰快递",
                            2: "圆通快递",
                            3: "中通快递",
                            4: "韵达快递",
                            5: "申通快递",
                            6: "百世汇通",
                            7: "中国邮政",
                          }[_vm.detail.expressCompany]
                        )
                      ),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "form_view" }, [
                  _c("div", { staticClass: "form_label f-s-14" }, [
                    _vm._v("快递单号："),
                  ]),
                  _c("div", { staticClass: "form_value f-s-14" }, [
                    _vm._v(_vm._s(_vm.detail.trackingNumber)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "form_row" }, [
                _c(
                  "div",
                  { staticClass: "form_view", staticStyle: { width: "377px" } },
                  [
                    _c("div", { staticClass: "form_label m-l-16 f-s-14" }, [
                      _vm._v("操作人："),
                    ]),
                    _c("div", { staticClass: "form_value f-s-14" }, [
                      _vm._v(_vm._s(_vm.detail.operateName)),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "form_view" }, [
                  _c("div", { staticClass: "form_label f-s-14" }, [
                    _vm._v("操作时间："),
                  ]),
                  _c("div", { staticClass: "form_value f-s-14" }, [
                    _vm._v(
                      _vm._s(_vm._f("filterTime")(_vm.detail.operateTime))
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }